import { useMutation } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders } from './recognition-leaderboard.loaders';

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};
